import type { FC } from "react";

import { PrintingProfileSearchForm } from "src/app/features/PrintingProfile/components/forms/PrintingProfileSearchForm";
import { PrintingProfilesTable } from "src/app/features/PrintingProfile/components/tables/PrintingProfilesTable";
import type { PrintingProfileEntity } from "src/app/features/PrintingProfile/types/PrintingProfileEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const PrintingProfilesPage: FC<NoneOwnProps> = () => {
    const table = <PrintingProfilesTable />;
    const searchForm = <PrintingProfileSearchForm />;
    const hasAccess = canAccess(ResourceName.PRINTING_PROFILES, "canRead");

    return (
        <PageLayout name="printingProfiles_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.printingProfiles" />
                    <ResourceManager<PrintingProfileEntity>
                        useDataGroup
                        dataMapperKey="printingProfilesTableData"
                        resource={ResourceName.PRINTING_PROFILES}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
